export const ECustomUserPropertyType = {
  OPEN_TEXT: 'open_text',
  DROPDOWN: 'dropdown',
  BOOLEAN: 'boolean',
} as const;

export type CustomUserPropertyType =
  (typeof ECustomUserPropertyType)[keyof typeof ECustomUserPropertyType];

export interface CustomUserPropertyOption {
  id: string;
  value: string;
  sort_order: number;
  external_id?: string | null;
}

export interface CustomUserProperty {
  id: string;
  organisation_id: string;
  name: string;
  description: string | null;
  type: CustomUserPropertyType;
  external_id?: string | null;
  options?: CustomUserPropertyOption[];
  created_at: string;
  updated_at: string;
}

export type CustomUserPropertiesResponse = {
  data: CustomUserProperty[];
  meta: null;
};

export type CustomUserPropertyResponse = {
  data: CustomUserProperty;
};

export type CreateCustomUserPropertyPayload = {
  name: string;
  description: string | null;
  type: CustomUserPropertyType;
  external_id?: string | null;
  options?: string[];
};

export interface CustomUserPropertyOptionInput {
  value: string;
  external_id?: string | null;
}

export type UpdateCustomUserPropertyPayload = {
  name?: string;
  description?: string | null;
  external_id?: string | null;
  options?: Array<string | CustomUserPropertyOptionInput>;
};

export interface UserCustomUserProperty {
  id: string;
  property_id: string;
  name: string;
  type: CustomUserPropertyType;
  value: string | boolean;
  option_id?: string;
  options?: CustomUserPropertyOption[];
}

export type UserCustomUserPropertiesResponse = {
  data: UserCustomUserProperty[];
  meta: null;
};

export type UserCustomUserPropertyResponse = {
  data: UserCustomUserProperty;
};

export type AvailableCustomUserPropertiesResponse = {
  data: CustomUserProperty[];
  meta: null;
};

export type AssignUserCustomUserPropertyPayload = {
  property_id: string;
  value?: string | boolean;
  option_id?: string;
};

export type UpdateUserCustomUserPropertyPayload = {
  value?: string | boolean;
  option_id?: string;
};
